import "./page-industries.scss";
import "../../js/core";
import "../../components/site-elements/sliders/section-slider-partners/section-slider-partners";
import setBlogSubscribeModalHandlers from "../../../assets/src/eos/js/modals/setBlogSubscribeModalHandlers";

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{
        jQuery('.js-partners-slider').owlCarousel({
          responsive: {
            568: {
              items: 3,
              slideBy: 1,
            },

            768: {
              items: 3,
              slideBy: 1,
              margin: 24,
            },
          },
          nav: true,
          dots: false,
          items: 2,
          slideBy: 1,
          loop: true,
          margin: 18,
          smartSpeed: 200,
        });
        
        $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
        });
    });
  });
});

setBlogSubscribeModalHandlers('#modalSubscribeSent');